import { Link, useRouteLoaderData, useSubmit } from "react-router-dom";

import UserInfo from "src/components/common/userInfo";
import { testerEmails } from "src/components/common/functions";
import { useAuthStore, User } from "../main/authStore";
import { Service } from "./types";

type FieldDef = {
    label: string;
    value?: React.ReactNode;
    show?: boolean;
};

export default function ServiceDetail() {
    const user = useAuthStore(state => state.user) as User;
    const { service } = useRouteLoaderData("service") as { service: Service };
    const submit = useSubmit();

    const handleDelete = (id: number | string | null) => {
        if (id === null || id === "") return;
        if (!window.confirm("Are you sure to delete this service?\n\nThis action cannot be undone.")) return;
        const formData = new FormData();
        formData.append("id", String(id));
        submit(formData, {
            method: "post",
            action: "Delete",
        });
    };

    const handleValidate = (id: number | string | null) => {
        if (id === null || id === "") return;
        if (!window.confirm("Are you sure to validate this service?")) return;
        let validateReason = window.prompt("reason to validate:");
        if (validateReason === null) return;
        while (validateReason === "") {
            window.alert("Reason is required to validate.");
            validateReason = window.prompt("reason to validate:");
            if (validateReason === null) return;
        }
        const formData = new FormData();
        formData.append("validateReason", validateReason);
        formData.append("id", String(id));
        submit(formData, {
            method: "post",
            action: "Validate",
        });
    };

    const handleVoid = (id: number | string | null) => {
        if (id === null || id === "") return;
        if (!window.confirm("Are you sure to void this service?")) return;
        let voidReason = window.prompt("reason to void:");
        if (voidReason === null) return;
        while (voidReason === "") {
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if (voidReason === null) return;
        }
        const formData = new FormData();
        formData.append("voidReason", voidReason);
        formData.append("id", String(id));
        submit(formData, {
            method: "post",
            action: "Void",
        });
    };

    const fields: FieldDef[] = [
        { label: "Service ID", value: service.id },
        { label: "Code", value: service.code },
        { label: "Name", value: service.name },
        { label: "Category", value: service.category },
        { label: "Price", value: service.price },
        { label: "Cost Type", value: service.costType },
        { label: "Validity", value: service.void === "yes" ? "Void" : "Valid" },
        {
            label: "Creator",
            show: !!service.creatorId || !!service.creatorName || !!service.createdAt,
            value: (
                <>
                    {service.creatorId || service.creatorName ? <UserInfo name = {service.creatorName ?? ""} id = {service.creatorId ?? ""} /> : null}
                    <span className = "ms-2 text-muted">{service.createdAt}</span>
                </>
            ),
        },
        {
            label: "Updater",
            show: !!service.updaterId || !!service.updaterName || !!service.updatedAt,
            value: (
                <>
                    {service.updaterId || service.updaterName ? <UserInfo name = {service.updaterName ?? ""} id = {service.updaterId ?? ""} /> : null}
                    <span className = "ms-2 text-muted">{service.updatedAt}</span>
                </>
            ),
        },
        {
            label: "Void Reason",
            show: !!service.voidReason,
            value: service.voidReason,
        },
        {
            label: "Validation Reason",
            show: !!service.validateReason,
            value: service.validateReason,
        },
    ];

    return (
        <div>
            <div className = "cssSeperateWhenWide ps-3 pt-3">
                <table className = "table table-fixed flex-grow-1 maxWidth-50 me-3">
                    <tbody className = "noTableTopBorder">
                        {fields.filter(field => field.show !== false && field.value !== undefined && field.value !== "").map((field, idx) => (
                            <tr key = {idx}>
                                <th>{field.label}</th>
                                <td>{field.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className = "d-flex flex-column flex-grow-1 maxWidth-50 me-3">
                    <fieldset className = "border rounded flex-grow-1 px-3">
                        <legend className = "fw-bold">
                            Notes
                        </legend>
                        <span className = "cssNotes">
                            {service.notes}
                        </span>
                    </fieldset>
                </div>
            </div>
            <div className = "my-3">
                {service.void === "yes" ? (
                    <>
                        {testerEmails.includes(user.email) ? (
                            <button className = "btn btn-primary" onClick = {() => handleValidate(service.id)}>Validate</button>
                        ) : null}
                    </>
                ) : (
                    <>
                        <Link to = "Edit" className = "btn btn-outline-primary ms-3">Edit</Link>
                        <button type = "button" className = "btn btn-danger ms-3" onClick = {() => handleVoid(service.id)}>Void</button>
                    </>
                )}
                {service.void === "yes" ? (
                    <button className = "btn btn-danger ms-3" onClick = {() => handleDelete(service.id)}>Delete</button>
                ) : null}
                <Link to = ".." relative = "path" className = "btn btn-outline-secondary float-end">Back</Link>
            </div>
        </div>
    );
}
